import { FLASHING_MC, GET_MC_GUID, IS_SYSTEM, PRINT_MC_INSTALL_INFO, PRINT_QR, TESTING_MC } from "../config/const";

const useElectron = () => {

    const isElectron = () => {
        return typeof window !== "undefined" && window.electronAPI;
    };

    const isElectronSystem = async () => {
        const isElec = isElectron();
        if (!isElec) return false;
        const res = await window.electronAPI.sendCommand(IS_SYSTEM);
        return res;
    };

    const flashingMc = async (data) => {
        const isElec = isElectron();
        if (!isElec) return false;
        const res = await window.electronAPI.sendCommand(FLASHING_MC, data);
        return res;
    };

    const flashTestingMC = async (data) => {
        const isElec = isElectron();
        if (!isElec) return false;
        const res = await window.electronAPI.sendCommand(TESTING_MC, data);
        return res;
    };

    const getMcGuid = async (data) => {
        const isElec = isElectron();
        if (!isElec) return false;
        const res = await window.electronAPI.sendCommand(GET_MC_GUID);
        return res;
    };

    const printQr = async (data) => {
        const isElec = isElectron();
        if (!isElec) return false;
        const res = await window.electronAPI.sendCommand(PRINT_QR, data);
        return res;
    };

    const printMcInstallInfo = async (data) => {
        const isElec = isElectron();
        if (!isElec) return false;
        const res = await window.electronAPI.sendCommand(PRINT_MC_INSTALL_INFO, data);
        return res;
    };

    return { isElectron, isElectronSystem, flashingMc, flashTestingMC, printQr, getMcGuid, printMcInstallInfo }
}
export default useElectron